import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import View from "../View.mjs";
import UtilArray from "../../../utils/UtilArray.mjs";
import RequisicaoDeCompraService from "./RequisicaoDeCompraService.js";
import CotacaoDePedidoDeCompraService from "./CotacaoDePedidoDeCompraService.js";
import OrdemDeServicoItemService from "./OrdemDeServicoItemService.js";

export default {

    async retornarCotacaoItens(cotacaoItens = []){

        try{

            //==================================================================//
            //==================== Constrói o Cotacoes Itens ===================//
            //==================================================================//
            // Isso apenas é feito pois ainda não há uma forma de enviar uma lista de parametros para uma view.

            cotacaoItens = await ERP.getManyById(Schema.COTACAO_DE_PEDIDO_DE_COMPRA_ITENS,cotacaoItens);
            if(cotacaoItens.status != 200){
                throw cotacaoItens;
            }

            let requisicoesDeCompra = cotacaoItens.data.map(({requisicaoDeCompra})=>requisicaoDeCompra);

            requisicoesDeCompra = await ERP.getManyById(Schema.REQUISICAO_DE_COMPRA,requisicoesDeCompra);
            if(requisicoesDeCompra.status != 200){
                throw requisicoesDeCompra;
            }

            let ordensDeServicoItens = requisicoesDeCompra.data.map(({ordemDeServicoItem})=>ordemDeServicoItem);

            ordensDeServicoItens = await ERP.getManyById(Schema.ORDEM_DE_SERVICO_ITENS,ordensDeServicoItens);
            if(ordensDeServicoItens.status != 200){
                throw ordensDeServicoItens;
            }

            cotacaoItens = cotacaoItens.data.map((cotacaoItem)=>{

                let requisicaoDeCompra = requisicoesDeCompra.data.find(({id})=> id == cotacaoItem.requisicaoDeCompra);
                let ordemDeServicoItem = ordensDeServicoItens.data.find(({id})=> id == requisicaoDeCompra.ordemDeServicoItem);

                requisicaoDeCompra.ordemDeServicoItem = ordemDeServicoItem;
                cotacaoItem.requisicaoDeCompra = requisicaoDeCompra;
                
                return cotacaoItem;

            });

            //==================================================================//
            //===================== Separar Cotacoes Itens =====================//
            //==================================================================//

            const { retornarParaLC , retornarParaDC } = cotacaoItens.reduce((acc, cotacaoItem)=>{

                if(cotacaoItem.requisicaoDeCompra.ordemDeServicoItem.status == "CT"){
                    acc.retornarParaLC.push(cotacaoItem);
                }else if(cotacaoItem.requisicaoDeCompra.ordemDeServicoItem.status == "AC"){
                    acc.retornarParaDC.push(cotacaoItem);
                }

                return acc;

            }, {retornarParaLC: [] , retornarParaDC: []});

            //==================================================================//
            //============== Retornar Cotacoes Itens de CT para LC =============//
            //==================================================================//

            let cotacaoItensValores = cotacaoItens?.map(({id})=>{

                return{
                    id:id,
                    status:"Cancelado"
                }
            });

            // Deixado assim para simplificar o código, está correto, mas nomenclatura errada devido a ausencia da requisição de PAI.
            let alteracaoCotacaoItens = await ERP.patchMany(Schema.COTACAO_DE_PEDIDO_DE_COMPRA_ITENS, cotacaoItensValores);
            if(alteracaoCotacaoItens.status != 200){
                throw alteracaoCotacaoItens;
            }

            //==================================================================//
            //============== Retornar Cotacoes Itens de CT para LC =============//
            //==================================================================//

            if(!UtilArray.isEmpty(retornarParaLC)){

                console.log({
                    operacao:"Retornar para LC:",
                    ids: retornarParaLC
                });

                requisicoesDeCompra = retornarParaLC.map(({requisicaoDeCompra})=>requisicaoDeCompra.id);

                requisicoesDeCompra = await RequisicaoDeCompraService.retornarRequisicoes(requisicoesDeCompra);
                if(requisicoesDeCompra.status != 200){
                    throw requisicoesDeCompra;
                }

            }

            //==================================================================//
            //============== Retornar Cotacoes Itens de AC para DC =============//
            //==================================================================//

            if(!UtilArray.isEmpty(retornarParaDC)){

                console.log({
                    operacao:"Retornar para DC:",
                    ids: retornarParaDC
                });

                ordensDeServicoItens = retornarParaDC.map(({requisicaoDeCompra})=>{

                    return {
                        id: requisicaoDeCompra.ordemDeServicoItem.id,
                        status: "DC"
                    }

                });

                ordensDeServicoItens = await OrdemDeServicoItemService.alterarItens(ordensDeServicoItens);
                if(ordensDeServicoItens.status != 200){
                    throw ordensDeServicoItens;
                }

            }

            //==================================================================//
            //======================= Encerra a Cotação ========================//
            //==================================================================//
            // Apenas se todos os Itens da Cotação foram Encerrados.

            let cotacoes = await CotacaoDePedidoDeCompraService.tentaEncerrarCotacoes();
            if(cotacoes.status != 200){
                console.log("Tenta encerrar a Cotação Falhou");
                throw cotacoes;
            }

            //==================================================================//
            //======================= Resposta Especial ========================//
            //==================================================================//

            let response = {
                data:{
                    retornadosParaLC: retornarParaLC,
                    retornadosParaDC: retornarParaDC,
                },
                statusText: "",
                status: 200
            };

            console.log(response);

            return response;

        }catch(e){

            console.log(e);
            return cotacaoItens;

        }

    },

    async alterarCotacaoItem(ordemDeServicoItemValores = {}, cotacaoItemValores = {}){

        let cotacaoItem;

        try{

            //==================================================================//
            //===================== Pega o Ordem de Servico ====================//
            //==================================================================//

            cotacaoItem = await ERP.getOneById(Schema.COTACAO_DE_PEDIDO_DE_COMPRA_ITENS, cotacaoItemValores.id);
            if(cotacaoItem.status != 200){
                throw cotacaoItem;
            }

            let requisicaoDeCompra = await ERP.getOneById(Schema.REQUISICAO_DE_COMPRA, cotacaoItem.data.requisicaoDeCompra);
            if(requisicaoDeCompra.status != 200){
                throw requisicaoDeCompra;
            }

            let ordemDeServicoItem = await ERP.getOneById(Schema.ORDEM_DE_SERVICO_ITENS, requisicaoDeCompra.data.ordemDeServicoItem);
            if(ordemDeServicoItem.status != 200){
                throw ordemDeServicoItem;
            }

            //==================================================================//
            //====================== Altera o Cotacao Item =====================//
            //==================================================================//

            cotacaoItem = await ERP.patchOne(Schema.COTACAO_DE_PEDIDO_DE_COMPRA_ITENS, cotacaoItemValores);
            if(cotacaoItem.status != 200){
                throw cotacaoItem;
            }

            //==================================================================//
            //=========== Altera o Status do Item da Ordem de Serviço ==========//
            //==================================================================//

            ordemDeServicoItemValores = {
                ...ordemDeServicoItemValores,
                id: ordemDeServicoItem.data.id,
                status:"AC",
            }

            ordemDeServicoItem = await OrdemDeServicoItemService.alterarItem(ordemDeServicoItemValores);
            if(ordemDeServicoItem.status != 200){
                throw ordemDeServicoItem;
            }

            console.log(cotacaoItem);

        }catch(e){

            console.log(e);
            return cotacaoItem;

        }

        return cotacaoItem;

    }

}